namespace GeniuzPOS.InitialData {
    export class PsCashCouponTypeSerialColumns {
        static columnsKey = 'InitialData.PsCashCouponTypeSerial';
    }
}
